import Interweave from "interweave";

import styles from "./AboutOurTalentComponent.module.css";

export default function AboutOurTalentComponent({ content, aboutUsCms }) {
  const aboutContent = content?.about,
    imageContent = content?.image;
    const { about_us, image, mission, vision } = aboutUsCms;

  return (
    <>
    <section className={styles.talent_about_us_container} id="band-about-us">
      <div className="container-fluid">
        <div className="row">
          <div className=" justify-content-center col-lg-5">
            <div className={styles.talent_image_sticky}>
              <img
                className={`${styles.talent_about_us_image} img-fluid`}
                src={process.env.IMAGE_LINK + imageContent?.value}
                alt="band-about-us-img"
              />
            </div>
          </div>
          <div className={`col-lg-7 ${styles.talent_about_us_content}`}>
            <div className={`d-flex flex-row flex-nowrap ${styles.talent_about_us_content_title_wrapper}`}>
              <h3 className={styles.talent_about_us_content_title}>
                {aboutContent?.value || "OUR TALENT"}
              </h3>
              <div className={styles.talent_about_us_content_title_dash}></div>
            </div>
            <h3 className={styles.talent_about_us_content_heading}>
              {aboutContent?.title}
            </h3>
            <div className={styles.talent_about_us_content_para}>
              <Interweave
                allowElements={false}
                content={aboutContent?.description || ""}
              />
            </div>
            <div className={styles.talent_about_us_shadow}></div>
          </div>
        </div>
      </div>
    </section>
    <section className="about_us_container" style={{backgroundPosition: "center",backgroundColor: "#2299dc"}}>
    <div className="about_us_container_bg"></div>
    <div className="about_us_container_icon1"></div>
    <div className="about_us_container_icon2"></div>
    <div className="container-fluid">
      <div className="row m-0 section_about_us">
        <div className="col-lg-7 col-md-12 about_us_detail_wrapper">
          <h2 className="section_title">{about_us?.value}</h2>
          <h1 className="section_heading">{about_us?.title}</h1>
          <p className="section_para">
            <Interweave
              allowElements={false}
              content={about_us?.description}
            />
          </p>
        </div>
        <div className="col-lg-5 col-md-12 about_us_image_wrapper">
          <img
            className="about_us_image"
            src={process.env.IMAGE_LINK + image?.value}
            alt="about us"
          />
        </div>
      </div>
      <div className="row section_mission">
        <div className="col-lg-6 col-md-12">
          <h6 className="section_title">{mission?.value}</h6>
          <h3 className="section_heading">{mission?.title}</h3>
        </div>
        <div className="col-lg-6 col-md-12">
          <div className="section_para_dash"></div>
          <p className="section_para">
            <Interweave
              allowElements={false}
              content={mission?.description}
            />
          </p>
        </div>
      </div>
      <div className="row section_vision">
        <div className="col-lg-6 col-md-12">
          <h6 className="section_title">{vision?.value}</h6>
          <h3 className="section_heading">{vision?.title}</h3>
        </div>
        <div className="col-lg-6 col-md-12">
          <div className="section_para_dash"></div>
          <p className="section_para">
            <Interweave
              allowElements={false}
              content={vision?.description}
            />
          </p>
        </div>
      </div>
    </div>
  </section>
  </>
  );
}
